/*
Grilla Expandible, con un boton que permite agregar datos a la cola.
Maneja los Pagos en la reserva y la nota de venta
*/
import React, { useState } from 'react'

import { FormatProps, handleInputChangeFormat } from '../utils/handleInputChangeFormat'
import { dateToday, formatDateEx, formatWithThousandSep, showPaymentWreserve } from '../utils/utils'
import { FieldToValidate, Rule, validateFields } from '../utils/validateForm'
import { Payment, PaymentTypeEnum } from '../interfaces/Reservation'
import { PaymentEx } from '../interfaces/SalenoteDto'

import { FormFields, InputFieldProps } from './FormFields'
import ConfirmationModal from './ConfirmationModal'
import { ButtonActionShort, ButtonMenuSet } from './Buttons'

interface Basic {
  date: string
  price: number
  price_format: string
}

interface Trans extends Basic {
  banco: string
}

interface Cheque extends Basic {
  banco: string
  cuenta: number
  numero: number
}

interface Vale extends Basic {
  banco: string
  numero: number
}

interface Otro extends Basic {
  description: string
}

interface GridExpProps {
  title: string
  array: Payment[] | PaymentEx[]
  onPaymentsChange: (payments: Payment[] | PaymentEx[]) => void
}

const ReservationPago: React.FC<GridExpProps> = ({ title, array, onPaymentsChange }) => {
  // const [payments, setPayments] = useState<Payment[]| PaymentEx[]>(array);
  const [showPagoEdit, setShowPagoEdit] = useState(false)
  const iniPayCost: Payment = {
    _id: Math.floor(Math.random() * 1000000).toString(),
    document: '',
    date: dateToday(),
    value: 0,
  }
  const iniTrans: Trans = { date: dateToday(), price: 0, price_format: '', banco: '' }
  const iniCheque: Cheque = {
    date: dateToday(),
    price: 0,
    price_format: '',
    banco: '',
    cuenta: 0,
    numero: 0,
  }
  const iniVale: Vale = {
    date: dateToday(),
    price: 0,
    price_format: '',
    banco: '',
    numero: 0,
  }
  const iniEfec: Basic = { date: dateToday(), price: 0, price_format: '' }
  const iniOtro: Otro = {
    date: dateToday(),
    price: 0,
    price_format: '',
    description: '',
  }

  const [newPayment, setNewPayment] = useState<Payment | null>(iniPayCost)
  const [trans, setTrans] = useState<Trans | null>(iniTrans)
  const [cheque, setCheque] = useState<Cheque | null>(iniCheque)
  const [vale, setVale] = useState<Vale | null>(iniVale)
  const [efec, setEfec] = useState<Basic | null>(iniEfec)
  const [otro, setOtro] = useState<Otro | null>(iniOtro)

  // Errores de validacion de los input
  const [errorsTrans, setErrorsTrans] = useState<{ [key: string]: string }>({})
  const [errorsVale, setErrorsVale] = useState<{ [key: string]: string }>({})
  const [errorsCheque, setErrorsCheque] = useState<{ [key: string]: string }>({})
  const [errorsEfec, setErrorsEfec] = useState<{ [key: string]: string }>({})
  const [errorsOtro, setErrorsOtro] = useState<{ [key: string]: string }>({})

  const [btnAceptarDisabledTrans, setBtnAceptarDisabledTrans] = useState<boolean>(true)
  const [btnAceptarDisabledVale, setBtnAceptarDisabledVale] = useState<boolean>(true)
  const [btnAceptarDisabledCheque, setBtnAceptarDisabledCheque] = useState<boolean>(true)
  const [btnAceptarDisabledEfec, setBtnAceptarDisabledEfec] = useState<boolean>(true)
  const [btnAceptarDisabledOtro, setBtnAceptarDisabledOtro] = useState<boolean>(true)

  type HTMLInputAll = HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
  const handleInputChangeTrans = (e: React.ChangeEvent<HTMLInputAll>) => {
    setBtnAceptarDisabledTrans(false)
    const formatProps: FormatProps[] = [{ name: 'price', name_format: 'price_format', isDecimal: false }]
    handleInputChangeFormat<Trans>(e, trans, setTrans, formatProps)
  }
  const handleInputChangeCheque = (e: React.ChangeEvent<HTMLInputAll>) => {
    setBtnAceptarDisabledCheque(false)
    const formatProps: FormatProps[] = [{ name: 'price', name_format: 'price_format', isDecimal: false }]
    handleInputChangeFormat<Cheque>(e, cheque, setCheque, formatProps)
  }
  const handleInputChangeVale = (e: React.ChangeEvent<HTMLInputAll>) => {
    setBtnAceptarDisabledVale(false)
    const formatProps: FormatProps[] = [{ name: 'price', name_format: 'price_format', isDecimal: false }]
    handleInputChangeFormat<Vale>(e, vale, setVale, formatProps)
  }
  const handleInputChangeEfec = (e: React.ChangeEvent<HTMLInputAll>) => {
    setBtnAceptarDisabledEfec(false)
    const formatProps: FormatProps[] = [{ name: 'price', name_format: 'price_format', isDecimal: false }]
    handleInputChangeFormat<Basic>(e, efec, setEfec, formatProps)
  }
  const handleInputChangeOtro = (e: React.ChangeEvent<HTMLInputAll>) => {
    setBtnAceptarDisabledOtro(false)
    const formatProps: FormatProps[] = [{ name: 'price', name_format: 'price_format', isDecimal: false }]
    handleInputChangeFormat<Otro>(e, otro, setOtro, formatProps)
  }

  const handleAgregarClick = () => {
    setNewPayment(iniPayCost)
    setShowPagoEdit(true)
  }

  const handlePagoAceptarClick = () => {
    const fieldsToValidate = fieldsToValidateGet()
    const validationErrors = validateFields(fieldsToValidate)

    if (Object.keys(validationErrors).length > 0) {
      if (esTransferencia) {
        setErrorsTrans(validationErrors)
      } else if (esCheque) {
        setErrorsCheque(validationErrors)
      } else if (esValeVista) {
        setErrorsVale(validationErrors)
      } else if (esEfectivo) {
        setErrorsEfec(validationErrors)
      } else {
        setErrorsOtro(validationErrors)
      }

      return
    }

    setErrorsTrans({})

    let price = 0
    let date = ''
    let type = 0

    if (newPayment) {
      let updatedPayment = { ...newPayment }
      let desc_value = ''

      if (esTransferencia) {
        desc_value = `Transferencia Electrónica, Bco: ${trans?.banco}`
        price = trans?.price ?? 0
        date = trans?.date ?? ''
        type = PaymentTypeEnum.ETransfer
        updatedPayment = { ...updatedPayment, bank: trans?.banco }
      } else if (esCheque) {
        desc_value = `Cheque, Bco: ${cheque?.banco}, Cta: ${cheque?.cuenta}, N°: ${cheque?.numero}`
        price = cheque?.price ?? 0
        date = cheque?.date ?? ''
        type = PaymentTypeEnum.Cheque
        updatedPayment = {
          ...updatedPayment,
          bank: cheque?.banco,
          account: cheque?.cuenta,
          number: cheque?.numero,
        }
      } else if (esValeVista) {
        desc_value = `Vale vista, Bco: ${vale?.banco}, N°: ${vale?.numero}`
        price = vale?.price ?? 0
        date = vale?.date ?? ''
        type = PaymentTypeEnum.VV
        updatedPayment = {
          ...updatedPayment,
          bank: vale?.banco,
          number: vale?.numero,
        }
      } else if (esEfectivo) {
        desc_value = 'Efectivo'
        price = efec?.price ?? 0
        date = efec?.date ?? ''
        type = PaymentTypeEnum.Cash
      } else {
        // OTRO
        desc_value = otro?.description ?? ''
        price = otro?.price ?? 0
        date = otro?.date ?? ''
        type = PaymentTypeEnum.Other
      }

      updatedPayment = {
        ...updatedPayment,
        document: desc_value,
        value: price,
        date: date,
        type: type,
      }

      // Set the updated payment and push it to payments array
      setNewPayment(updatedPayment)
      // Esto es para resolver un problema de la "asincronicidad "
      const aux = [...array, updatedPayment]

      onPaymentsChange(aux)
      // reseteamos

      clear()
    }
    setShowPagoEdit(false)
  }

  const fieldsToValidateGet = () => {
    let fieldsToValidate: FieldToValidate[] = []

    if (esTransferencia) {
      fieldsToValidate = [
        { name: 'banco', value: trans?.banco, rule: Rule.REQUIRED },
        { name: 'price_format', value: trans?.price_format, rule: Rule.GREATER_ZERO },
        { name: 'date', value: trans?.date, rule: Rule.REQUIRED },
      ]
    } else if (esCheque) {
      fieldsToValidate = [
        { name: 'price_format', value: cheque?.price_format, rule: Rule.GREATER_ZERO },
        { name: 'date', value: cheque?.date, rule: Rule.REQUIRED },
        { name: 'banco', value: cheque?.banco, rule: Rule.REQUIRED },
        { name: 'cuenta', value: cheque?.cuenta, rule: Rule.GREATER_ZERO },
        { name: 'numero', value: cheque?.numero, rule: Rule.GREATER_ZERO },
      ]
    } else if (esValeVista) {
      fieldsToValidate = [
        { name: 'price_format', value: vale?.price_format, rule: Rule.GREATER_ZERO },
        { name: 'date', value: vale?.date, rule: Rule.REQUIRED },
        { name: 'banco', value: vale?.banco, rule: Rule.REQUIRED },
        { name: 'numero', value: vale?.numero, rule: Rule.GREATER_ZERO },
      ]
    } else if (esEfectivo) {
      fieldsToValidate = [
        { name: 'price_format', value: efec?.price_format, rule: Rule.GREATER_ZERO },
        { name: 'date', value: efec?.date, rule: Rule.REQUIRED },
      ]
    } else if (esOtro) {
      fieldsToValidate = [
        { name: 'price_format', value: otro?.price_format, rule: Rule.GREATER_ZERO },
        { name: 'date', value: otro?.date, rule: Rule.REQUIRED },
        { name: 'description', value: otro?.description, rule: Rule.REQUIRED },
      ]
    }

    return fieldsToValidate
  }
  const handlePagoCancelarClick = () => {
    setNewPayment({ _id: Math.floor(Math.random() * 1000000).toString(), document: '', date: '', value: 0 })
    setShowPagoEdit(false)
    clear()
  }

  const [selectedIndex, setSelectedIndex] = useState<number>(-1)
  const esTransferencia = selectedIndex === 0
  const esCheque = selectedIndex == 1
  const esValeVista = selectedIndex == 2
  const esEfectivo = selectedIndex === 3
  const esOtro = selectedIndex === 4

  const [isModalOpen, setIsModalOpen] = useState(false)
  const [selectedItemId, setSelectedItemId] = useState<string | null>(null)

  const onDeleteClick = (key: string) => {
    setSelectedItemId(key) // Store the item ID in the state
    setIsModalOpen(true)
  }
  const handleConfirm = () => {
    setIsModalOpen(false)
    // Perform delete action here
    const aux = array.filter((item) => item._id !== selectedItemId)
    onPaymentsChange(aux)
    console.log('Item deleted:' + selectedItemId)
    setSelectedItemId(null)
  }

  const handleCancel = () => {
    setIsModalOpen(false)
    setSelectedItemId(null)
  }
  const chequeFields: Array<InputFieldProps> = [
    { label: 'Banco', name: 'banco', value: cheque?.banco ?? '', type: 'string' },
    { label: 'Cuenta', name: 'cuenta', value: cheque?.cuenta, type: 'number' },
    { label: 'Número', name: 'numero', value: cheque?.numero, type: 'number' },
    { label: 'Fecha', name: 'date', value: cheque?.date ?? '', type: 'date' },
    { label: 'Valor', name: 'price_format', value: cheque?.price_format ?? '', type: 'string' },
  ]
  const transFields: Array<InputFieldProps> = [
    { label: 'Banco', name: 'banco', value: trans?.banco ?? '', type: 'string' },
    { label: 'Fecha', name: 'date', value: trans?.date ?? '', type: 'date' },
    { label: 'Valor', name: 'price_format', value: trans?.price_format ?? '', type: 'string' },
  ]
  const valeFields: Array<InputFieldProps> = [
    { label: 'Banco', name: 'banco', value: vale?.banco ?? '', type: 'string' },
    { label: 'Número', name: 'numero', value: vale?.numero, type: 'number' },
    { label: 'Fecha', name: 'date', value: vale?.date ?? '', type: 'date' },
    { label: 'Valor', name: 'price_format', value: vale?.price_format ?? '', type: 'string' },
  ]

  const efectivoFields: Array<InputFieldProps> = [
    { label: 'Fecha', name: 'date', value: efec?.date ?? '', type: 'date' },
    { label: 'Valor', name: 'price_format', value: efec?.price_format ?? '', type: 'string' },
  ]

  const otroFields: Array<InputFieldProps> = [
    { label: 'Descripción', name: 'description', value: otro?.description ?? '', type: 'string' },
    { label: 'Fecha', name: 'date', value: otro?.date ?? '', type: 'date' },
    { label: 'Valor', name: 'price_format', value: otro?.price_format ?? '', type: 'string' },
  ]
  const clear = (): void => {
    setNewPayment({ ...iniPayCost })
    setTrans({ ...iniTrans })
    setCheque({ ...iniCheque })
    setVale({ ...iniVale })
    setEfec({ ...iniEfec })
    setOtro({ ...iniOtro })

    setErrorsTrans({})
    setErrorsCheque({})
    setErrorsVale({})
    setErrorsEfec({})
    setErrorsOtro({})

    setSelectedIndex(-1)
    setBtnAceptarDisabledTrans(true)
    setBtnAceptarDisabledCheque(true)
    setBtnAceptarDisabledVale(true)
    setBtnAceptarDisabledEfec(true)
    setBtnAceptarDisabledOtro(true)
  }

  let formFields: InputFieldProps[] = []
  let errors: { [key: string]: string } = {}
  let handleInputChange: (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void = () => {}
  let btnAceptarDisabled = true

  if (esTransferencia) {
    formFields = transFields
    handleInputChange = handleInputChangeTrans
    errors = errorsTrans
    btnAceptarDisabled = btnAceptarDisabledTrans
  } else if (esCheque) {
    formFields = chequeFields
    handleInputChange = handleInputChangeCheque
    errors = errorsCheque
    btnAceptarDisabled = btnAceptarDisabledCheque
  } else if (esValeVista) {
    formFields = valeFields
    handleInputChange = handleInputChangeVale
    errors = errorsVale
    btnAceptarDisabled = btnAceptarDisabledVale
  } else if (esEfectivo) {
    formFields = efectivoFields
    handleInputChange = handleInputChangeEfec
    errors = errorsEfec
    btnAceptarDisabled = btnAceptarDisabledEfec
  } else if (esOtro) {
    formFields = otroFields
    handleInputChange = handleInputChangeOtro
    errors = errorsOtro
    btnAceptarDisabled = btnAceptarDisabledOtro
  }

  return (
    <div>
      <div className="flex">
        <div className="text-2xl w-48">{title}</div>
        <div className="flex-1">
          <ButtonActionShort label="Agregar..." handleButtonClick={handleAgregarClick} />
        </div>
      </div>
      <div className="grid grid-cols-6 border-t">
        {array
          .filter((p) => p.type !== PaymentTypeEnum.Credit)
          .map((payment) => (
            <React.Fragment key={payment._id}>
              <div className="border-b pr-4 col-span-3">{showPaymentWreserve(payment)}</div>
              <div className="border-b pr-4">{formatDateEx(payment.date)}</div>
              <div className="border-b pr-4 text-right">${formatWithThousandSep(payment.value)}</div>
              <button
                className="border-b pr-4 cursor-pointer hover:text-red-500 focus:outline-none focus:ring-2"
                onClick={() => onDeleteClick(payment._id)}
                aria-label="Delete"
              >
                &#x1F5D1;
              </button>
            </React.Fragment>
          ))}
        {isModalOpen && (
          <ConfirmationModal
            message="¿Estás seguro de eliminar este pago?"
            onConfirm={handleConfirm}
            onCancel={handleCancel}
          />
        )}
      </div>
      {showPagoEdit && (
        <>
          <div className="mt-10 ">
            <ButtonMenuSet
              short={true}
              captions={['Transferencia Electrónica', 'Cheque', 'Vale Vista', 'Efectivo', 'Otro']}
              clickedIndex={selectedIndex}
              handleButtonClick={(idx) => setSelectedIndex(idx)}
            />

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-4 mt-4">
              <FormFields fields={formFields} handleInputChange={handleInputChange} errors={errors} />
            </div>
          </div>
          {selectedIndex > -1 && (
            <div className="flex justify-center mt-4 space-x-4">
              <ButtonActionShort
                label="Aceptar"
                handleButtonClick={handlePagoAceptarClick}
                disabled={btnAceptarDisabled}
              />
              <ButtonActionShort label="Cancelar" handleButtonClick={handlePagoCancelarClick} />
            </div>
          )}
          {selectedIndex === -1 && <div className="mb-32">&#xA0; </div>}
        </>
      )}
    </div>
  )
}

export default ReservationPago
